module.exports = __webpack_public_path__ + "img/doc.e31e5cb1.svg";